<div mat-dialog-title class="confirmation-title-icon">
  <i class="material-icons">report_problem</i>
  <h2>{{data.title}}</h2>
</div>

<div mat-dialog-content>{{data.message}}</div>
<div mat-dialog-actions align="end">
  <button type="button" class="btn btn-secondary" (click)="onCancel()"><span class="material-icons">close</span> No</button>
  <button type="button" class="btn btn-primary" (click)="onConfirm()"><span class="material-icons">check</span> Yes</button>
</div>
